import { gql } from "gql";

export const SAVE_DYNAMIC_ATTRIBUTE = gql(/* GraphQL */ `
  mutation SaveDynamicAttribute($attribute: SimpleDynamicAttributeInput!) {
    saveSimpleDynamicAttribute(attribute: $attribute)
  }
`);
